import * as React from 'react';
import DisplayLabel from './DisplayLabel';
import DisplayValue from './DisplayValue';

interface DisplayLabelValueProps {
  label: React.ReactNode;
  children: React.ReactNode;
}

export default function DisplayLabelValue(props: DisplayLabelValueProps) {
  return (
    <div style={{ paddingBottom: '16px' }}>
      <div>
        <DisplayLabel>{props.label}</DisplayLabel>
      </div>
      <div>
        <DisplayValue>{props.children}</DisplayValue>
      </div>
    </div>
  );
}
